import { GRAPH_LABEL_TEXT_COLOR } from '../../../../../modules/consts/caf'

export const CustomYTick = ({
  tick,
  scrollX,
  xGap = 0,
  yGap = 0,
  mark = '',
  size = 12,
  color = GRAPH_LABEL_TEXT_COLOR,
  backgroundColor = '',
  width = 0,
  chartHeight = 240,
}) => {
  return (
    <g transform={`translate(${tick.x + +scrollX + xGap},${tick.y + yGap})`}>
      <text
        textAnchor="end"
        dominantBaseline="right"
        style={{
          fill: color,
          fontSize: size,
        }}
      >
        {tick.value}
        {mark}
      </text>
      {!!backgroundColor && tick?.tickIndex === 0 && scrollX > 20 && (
        <defs>
          <linearGradient id="gradient" gradientTransform="rotate(0)">
            <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
            <stop offset="80%" stopColor="rgba(255, 255, 255, 1)" />
            <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
          </linearGradient>
        </defs>
      )}
      {!!backgroundColor && tick?.tickIndex === 0 && scrollX > 20 && (
        <rect
          x={-width - xGap - 100}
          y={-chartHeight}
          width={width + 125}
          height={chartHeight + 30}
          // fill={backgroundColor}
          fill={'url(#gradient)'}
          style={{ zIndex: -500 }}
        ></rect>
      )}
    </g>
  )
}

export const CustomXTick = ({ tick, xGap = 0, yGap = 0, mark = '', size = 12, color = '#ABBCD5' }) => {
  return (
    <g transform={`translate(${tick.x + xGap},${tick.y + yGap})`}>
      <text
        textAnchor="end"
        dominantBaseline="right"
        style={{
          fill: color,
          fontSize: size,
        }}
      >
        {tick.value}
      </text>
    </g>
  )
}
